import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterAutocomplete_template } from "./filterAutocomplete_template";


declare var ko: any;

export class header_menu_edit_template extends vnTemplate {

    public tagTypeFilter: filterAutocomplete_template;

    public contentTypeFilter: filterAutocomplete_template;

    protected getTemplateName(): string {
        return 'header_menu_edit_template';
    }
    protected getTemplateHtml(): string {
        return (
            /*html*/`
            <div class="form-header">

                    <input type="hidden">

                    <!-- ko ifnot: id() -->
                    <h3 class="form-title icon i-listing-page">New Listing Page</h3>
                    <!-- /ko -->

                    <!-- ko if: id() -->
                    <h3 class="form-title icon i-listing-page" data-bind="text: name"></h3>
                    <!-- /ko -->

                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>

                </div>

                <div class="w-form-body no-border">

                    <div class="form-body full-width">
                        <strong class="form-sub-title">Information</strong>
                    </div>

                </div>

                <div class="w-form-body information">

                    <div class="form-body no-padding">
                        <div class="form-group">
                            <label for="name" class="form-label">Name</label>
                            <input data-bind="value: name" class="input-text"/>
                        </div>
                    </div>
                    

                </div>
                <div class="w-form-body no-border">

                    <div class="form-body full-width">
                        <strong class="form-sub-title">Content Types</strong>
                        <div class="form-group">
                            ${this.contentTypeFilter.getHtmlBuild()}
                        
                            <div data-bind="foreach: oldContentTypes, css: { 'is-disable' : idField() }">
                                <div class="btn-selection"><span data-bind="text: name + ' ' + formattedDataset"></span></div>
                            </div>
                            <div data-bind="foreach: contentTypes">
                                <div class="btn-selection"><span data-bind="text: name()"></span><button class="icon i-x-after" type="button" data-bind="click: onClickRemoveContentType "></button></div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="w-form-body no-border">

                    <div class="form-body full-width">
                        <strong class="form-sub-title">Tag Types</strong>
                        <div class="form-group">
                            ${this.tagTypeFilter.getHtmlBuild()}
                        
                            <div data-bind="foreach: oldTagTypes, css: { 'is-disable' : idField() }">
                                <div class="btn-selection"><span data-bind="text: name + ' ' + formattedDataset"></span></div>
                            </div>
                            <div data-bind="foreach: tagTypes">
                                <div class="btn-selection"><span data-bind="text: name"></span><button class="icon i-x-after" type="button" data-bind="click: onClickRemoveTagType "></button></div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
                
            
        `);
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            id: ko.observable(null),
            name: ko.observable(''),
            oldContentTypes: ko.observableArray([]),
            oldTagTypes: ko.observableArray([]),
            contentTypes: ko.observableArray([]),
            tagTypes: ko.observableArray([]),
            idField: ko.observable(null),
            onClickCancel: (data,event) =>{
                self.onClickCancel(data,event);
            },
            onClickSave: (data, event) =>{
                self.onClickSave(data,event);
            },
            onClickRemoveTagType:(data,event) =>{
                self.onClickRemoveTagType(data)
            },
            onClickRemoveContentType:(data, event) =>{
                self.onClickRemoveContentType(data)
            }
        }
    }

    protected initPartial(): void {

        this.tagTypeFilter = new filterAutocomplete_template("filterAutocompleteTagType_template", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.setPlaceholderAndLabel( 'Tag Type' );
        this.tagTypeFilter.setIsShowCurrentSelection(false);
        this.tagTypeFilter.setAddNewOptionEnabled(false);

        this.contentTypeFilter = new filterAutocomplete_template("filterAutocompleteContentType_template", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setPlaceholderAndLabel( 'Content Type' );
        this.contentTypeFilter.setIsShowCurrentSelection(false);

    }
    
    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }
    
    private onClickCancel(data,event){
        this.caller.cancelMenu();
    }

    private onClickSave(data,event){
        this.caller.saveMenu();
    }

    public setMenu(menusObj){

        this.getTemplateViewModel().name(menusObj.name);
        this.getTemplateViewModel().id(menusObj.id);
        this.setContentTypes(menusObj.idContentTypes);
        this.setTagTypes(menusObj.idTagTypes);
    }

    public onClickRemoveTagType(data){

        const tagTypes = this.getTemplateViewModel().tagTypes();
        const filteredTagTypes = tagTypes.filter((tt) => tt.id !== data.id);

        // Update the observable array
        this.getTemplateViewModel().tagTypes(filteredTagTypes);
    }

    public onClickRemoveContentType(data){

        const contentTypes = this.getTemplateViewModel().contentTypes();
        const filteredContentTypes = contentTypes.filter((ct) => ct.id !== data.id);

        // Update the observable array
        this.getTemplateViewModel().contentTypes(filteredContentTypes);
    }

    public setContentTypes(contentTypes): void {
        let self = this;
    
        contentTypes.forEach((type) => {
            
            if(!(ko.isObservable(type.name) && ko.isObservable(type.id))){

                type.name = ko.observable(type.name); 
                type.id = ko.observable(type.id);
        
                
                type.onClickRemoveContentType = function () {
                    self.onClickRemoveContentType(type); 
                };
            }
        });
    
        // Update the observable array with modified items
        this.getTemplateViewModel().contentTypes([]);
        this.getTemplateViewModel().contentTypes(contentTypes);
    }
    
    
    public setTagTypes(tagTypes): void {
        let self = this;
    
        tagTypes.forEach((type) => {
            if(!(ko.isObservable(type.name) && ko.isObservable(type.id))){

                type.name = ko.observable(type.name);   
                type.id = ko.observable(type.id);
        
                type.onClickRemoveTagType = function () {
                    self.onClickRemoveTagType(type); 
                };
            }
        });
    
        this.getTemplateViewModel().tagTypes([]);
        this.getTemplateViewModel().tagTypes(tagTypes);
    }

    
}



// WEBPACK FOOTER //
// ./js/components/templates/header_menu_edit_template.ts